import { ReactNode } from 'react';
import cx from 'classnames';

export interface ISwitchProps {
  label?: ReactNode;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

/** On/off that applies at once — a setting, not a form answer (that is `Checkbox`). */
export const Switch = ({ label, checked = false, onChange, disabled = false, className }: ISwitchProps) => (
  <label
    className={cx(
      'flex min-w-0 max-w-full items-center gap-5',
      disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
      className,
    )}
  >
    <input
      type="checkbox"
      role="switch"
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange?.(e.target.checked)}
      className="peer sr-only"
    />
    <span
      aria-hidden
      className={cx(
        'relative h-7.5 w-12.5 shrink-0 rounded-full transition-colors',
        'peer-focus-visible:ring-2 peer-focus-visible:ring-primary peer-focus-visible:ring-offset-2',
        "after:absolute after:left-1.25 after:top-1.25 after:h-5 after:w-5 after:rounded-full after:border after:content-[''] after:transition-all",
        'peer-checked:after:translate-x-5',
        disabled
          ? 'bg-line-strong after:border-ink-subtle after:bg-ink-subtle peer-checked:after:border-line-strong peer-checked:after:bg-line-strong'
          : 'bg-line after:border-ink-muted after:bg-ink-muted hover:bg-line-strong peer-checked:after:border-success peer-checked:after:bg-success',
      )}
    />
    {label && <span className="min-w-0 break-words text-body-l-strong text-ink">{label}</span>}
  </label>
);
